import { FORM_TYPE } from './custom-define-type';

export const DEFAULT_CANDIDATE_STATUSES = [
  "Pre Application",
  "Applied",
  "Rejected",
  "Inactive",
  "Application Approved",
  "Interview Complete",
  "Document Signed",
  "Reference Check Complete",
  "Background Check Complete",
  "Profile Complete",
  "Hired"
];

export const DEFAULT_TABLE_FIELDS_OPTIONS = [
  {
    label: "Name",
    model: "first_name_last_name",
  },
  {
    label: "Secondary Name",
    model: "secondary_first_name_secondary_last_name",
  },
  {
    label: "Status",
    model: "status",
  },
  {
    label: "Status 2",
    model: "second_status",
  },
  {
    label: "Registration Date",
    model: "created_date",
  },
  {
    label: "Last Login",
    model: "last_login",
  },
  {
    label: "Last Updated",
    model: "last_updated_date",
  },
  {
    label: "Last Contacted",
    model: "last_contacted_date",
  },
  {
    label: "Last Active",
    model: "last_activity",
  },
  {
    label: "Types",
    model: "types",
  },
  {
    label: "Admin Manager",
    model: "admin_manager",
  },
  {
    label: "Locations",
    model: "locations",
  },
  {
    label: "Language",
    model: "language",
  },
  {
    label: "Tags",
    model: "tags",
  },
  {
    label: "Profile Picture",
    model: "profile_pic",
  },
  {
    label: "ID",
    model: "id",
  },
  {
    label: "Checklist",
    model: "checklist",
  },
  {
    label: "Profile Checklist",
    model: "profile_checklist",
  },
];
export const SHIFT_JOB_CSV_OPTIONS = [
  {
    displayLabel: "Client Name",
    label: "Client",
    model: "poster_name",
  },
  {
    displayLabel: "Poster Employer Name",
    label: "Poster Employer Name",
    model: "poster__employer_name",
  },
  {
    displayLabel: "Poster First Name",
    label: "Poster First Name",
    model: "poster__first_name",
  },
  {
    displayLabel: "Poster Email",
    label: "Poster Email",
    model: "poster__email",
  },
  {
    displayLabel: "Poster Last Name",
    label: "Poster Last Name",
    model: "poster__last_name",
  },
  {
    displayLabel: "Client ID",
    label: "Client ID",
    model: "poster_id",
  },
  {
    displayLabel: "Date",
    label: "Date",
    model: "date",
  },
  {
    displayLabel: "Candidate Name",
    label: "Candidate",
    model: "filler_name",
  },
  {
    displayLabel: "Candidate",
    label: "Candidate ID",
    model: "filler_id",
  },
  {
    displayLabel: "Job Type",
    label: "Job Type",
    model: "job_type",
  },
  {
    displayLabel: "Title",
    label: "Title",
    model: "title",
  },
  {
    displayLabel: "Booked Start Time",
    label: "Booked Start Time",
    model: "start_time",
  },
  {
    displayLabel: "Booked End Time",
    label: "Booked End Time",
    model: "end_time",
  },
  {
    displayLabel: "Actual Start Time",
    label: "Actual Start Time",
    model: "actual_start_time",
  },
  {
    displayLabel: "Actual End Time",
    label: "Actual End Time",
    model: "actual_end_time",
  },
  {
    displayLabel: "Total Hours",
    label: "Total Hours",
    model: "hours_worked",
  },
  // {
  //   displayLabel: "Regular Hours",
  //   label: "Regular Hours",
  //   model: "decimal2",
  // },
  // {
  //   displayLabel: "OT Hours",
  //   label: "OT Hours",
  //   model: "decimal3",
  // },
  {
    displayLabel: "Paid",
    label: "Paid",
    model: "decimal4",
  },
  {
    displayLabel: "Admin Note",
    label: "Admin Note",
    model: "admin_notes",
  },
  {
    displayLabel: "Admin Notes",
    label: "Admin Notes",
    model: "list_admin_notes",
  },
  {
    displayLabel: "Clock In Note",
    label: "Clock In Note",
    model: "clock_in_notes",
  },
  {
    displayLabel: "Clock Out Note",
    label: "Clock Out Note",
    model: "clock_out_notes",
  },
  {
    displayLabel: "Mileage",
    label: "Mileage",
    model: "mileage",
  },
  {
    displayLabel: "Reimbursement",
    label: "Reimbursement",
    model: "reimbursement",
  },
  {
    displayLabel: "Bonus",
    label: "Bonus",
    model: "bonus",
  },
  {
    displayLabel: "Status",
    label: "Status",
    model: "status",
  },
  {
    displayLabel: "Tags",
    label: "Tags",
    model: "poster__tags",
  },
  {
    displayLabel: "Hours Booked",
    label: "Hours Booked",
    model: "hours_booked",
  },
  {
    displayLabel: "Number of Children",
    label: "Number of Children",
    model: "number_children",
  },
];

export const DEFAULT_SHIFT_JOB_CSV_OPTIONS = [
  { displayLabel: "Client", label: "Client", model: "poster_name" },
  { displayLabel: "Client ID", label: "Client ID", model: "poster_id" },
  { displayLabel: "Date", label: "Date", model: "date" },
  { displayLabel: "Candidate", label: "Candidate", model: "filler_name" },
  {
    displayLabel: "Candidate ID",
    label: "Candidate ID",
    model: "filler_id",
  },
  { displayLabel: "Job Type", label: "Job Type", model: "job_type" },
  { displayLabel: "Title", label: "Title", model: "title" },
  {
    displayLabel: "Booked Start Time",
    label: "Booked Start Time",
    model: "start_time",
  },
  {
    displayLabel: "Booked End Time",
    label: "Booked End Time",
    model: "end_time",
  },
  {
    displayLabel: "Actual Start Time",
    label: "Actual Start Time",
    model: "actual_start_time",
  },
  {
    displayLabel: "Actual End Time",
    label: "Actual End Time",
    model: "actual_end_time",
  },
  {
    displayLabel: "Regular Hours",
    label: "Regular Hours",
    model: "decimal2",
  },
  { displayLabel: "OT Hours", label: "OT Hours", model: "decimal3" },
  { displayLabel: "Paid", label: "Paid", model: "decimal4" },
  {
    displayLabel: "Admin Note",
    label: "Admin Note",
    model: "admin_notes",
  },
  {
    displayLabel: "Clock In Note",
    label: "Clock In Note",
    model: "clock_in_notes",
  },
  {
    displayLabel: "Clock Out Note",
    label: "Clock Out Note",
    model: "clock_out_notes",
  },
  { displayLabel: "Mileage", label: "Mileage", model: "mileage" },
  {
    displayLabel: "Reimbursement",
    label: "Reimbursement",
    model: "reimbursement",
  },
  { displayLabel: "Bonus", label: "Bonus", model: "bonus" },
  { displayLabel: "Status", label: "Status", model: "status" },
];

export const DEFAULT_EMPLOYER_STATUSES = [
  "Pre Application",
  "Applied",
  "Inactive",
  "Application Approved",
  "Documents Signed",
  // 'Payment Info Entered',
  // "Payment Link Sent",
  "Initial Payment Made",
  "Consultation Booked",
  "Consultation Complete",
  "Job Posted",
  // "Nanny Assigned",
  "Active",
  "Lost",
  "Complete"
];

export const DEFAULT_CANDIDATE_CLIENT_RELATIONSHIP_STATUS = [
  "Potential Fit",
  "Candidate Consideration",
  "Candidate Interested",
  "Candidate Not Interested",
  "Declined",
  "Under Consideration",
  "No Longer Available",
  "Interested",
  "Not Interested",
  'Interviewing',
  'Not Interested After Interview',
  'Trialing',
  'Not Interested After Trial',
  "Offer Extended",
  "Assigned",
  "Hired",
  "Favorite",
  "Got Let Go",
  "Fired",
  "Quit",
  "Do Not Match"
];

export const DEFAULT_LIST_COLORS = [
  "#ff6969",
  "#FFB6C1",
  "#bfbfff",
  "#c2c2c2",
  "#9c9c9c",
  "#6dc96d",
  "#f5f5dc",
  "#03c6fc",
  "#0331fc",
  "#00ff37"
];

export const DEFAULT_SHIFT_JOB_STATUSES = [
  { status: "Requested", color: DEFAULT_LIST_COLORS[0] },
  { status: "Cancelled", color: DEFAULT_LIST_COLORS[3] },
  { status: "Broadcasted", color: DEFAULT_LIST_COLORS[5] },
  { status: "Assigned", color: DEFAULT_LIST_COLORS[1] },
  { status: "In Progress", color: DEFAULT_LIST_COLORS[2] },
  { status: "Completed", color: DEFAULT_LIST_COLORS[4] },
  { status: "Charged", color: DEFAULT_LIST_COLORS[7] }
];

export const DEFAULT_DASHBOARD_TABLE_MODELS_CANDIDATE = [
  "first_name_last_name",
  "email",
  "created_date",
  "last_login",
  "status"
];

export const DEFAULT_DASHBOARD_TABLE_MODELS_EMPLOYER = [
  "first_name_last_name",
  "email",
  "phone",
  "created_date",
  "status"
];

export const DEFAULT_DASHBOARD_TABLE_FIELDS_CANDIDATE = [
  {
    displayLabel: "Name",
    model: "first_name_last_name"
  },
  {
    displayLabel: "Email",
    model: "email"
  },
  {
    displayLabel: "Registration Date",
    model: "created_date"
  },
  {
    displayLabel: "Last Login",
    model: "last_login"
  },
  {
    displayLabel: "Status",
    model: "status"
  }
];

export const DEFAULT_DASHBOARD_TABLE_FIELDS_EMPLOYER = [
  {
    displayLabel: "Name",
    model: "first_name_last_name"
  },
  {
    displayLabel: "Email",
    model: "email"
  },
  {
    displayLabel: "Phone",
    model: "phone"
  },
  {
    displayLabel: "Registration Date",
    model: "created_date"
  },
  {
    displayLabel: "Status",
    model: "status"
  }
];

export const DEFAULT_TIME_SHEET_TABLE_FIELDS = [
  {
    displayLabel: "Candidate",
    model: "filler_name"
  },
  {
    displayLabel: "Client",
    model: "poster_name"
  },
  {
    displayLabel: "Location",
    model: "locations"
  },
  {
    displayLabel: "Date",
    model: "date"
  },
  {
    displayLabel: "Category",
    model: "category"
  },
  {
    displayLabel: "Title",
    model: "title"
  },
  {
    displayLabel: "Booked Start",
    model: "start_time"
  },
  {
    displayLabel: "Booked End",
    model: "end_time"
  },
  {
    displayLabel: "Clocked Start",
    model: "actual_start_time",
    noteModel: "clock_in_notes"
  },
  {
    displayLabel: "Clocked End",
    model: "actual_end_time",
    noteModel: "clock_out_notes"
  },
  {
    displayLabel: "Hours Worked",
    model: "hours_worked",
  },
  {
    displayLabel: "Candidate Pay",
    model: "total_candidate_pay",
  },
  {
    displayLabel: "Total Client Charge",
    model: "total_client_charge",
  },
  // {
  //   displayLabel: "Regular"
  // },
  // {
  //   displayLabel: "OT"
  // },
  // {
  //   displayLabel: "Mileage",
  //   model: "mileage"
  // },
  // {
  //   displayLabel: "Paid",
  //   model: "decimal4"
  // },
  {
    displayLabel: "Status",
    model: "status",
    noteModel: "admin_notes"
  }
];

export const DEFAULT_MY_JOBS_TABLE_FIELDS = [
  {
    displayLabel: "Date",
    model: "date"
  },
  {
    displayLabel: "Details",
    model: "job-details-slot"
  },
  {
    displayLabel: "Booked Start",
    model: "start_time"
  },
  {
    displayLabel: "Booked End",
    model: "end_time"
  },
  {
    displayLabel: "Clocked Start",
    model: "actual_start_time"
  },
  {
    displayLabel: "Clocked End",
    model: "actual_end_time"
  },
  {
    displayLabel: "Regular"
  },
  {
    displayLabel: "OT"
  },
  {
    displayLabel: "Status",
    model: "status"
  },
  {
    displayLabel: "Actions",
    model: "custom-actions-slot"
  }
];

export const DEFAULT_PLACEMENT_JOB_TABLE_FIELDS = [
  {
    label: "Title",
    displayLabel: "Title",
    model: "title",
  },
  {
    label: "Date Created",
    displayLabel: "Date Created",
    model: "created_date",
  },
  {
    label: "Status",
    displayLabel: "Status",
    model: "status",
  },
  {
    label: "Manager",
    displayLabel: "Manager",
    model: "adminName",
  },
  {
    label: "Client",
    displayLabel: "Client",
    model: "poster_name",
  },
  {
    label: "City",
    displayLabel: "City",
    model: "city",
  },
  {
    label: "State",
    displayLabel: "State",
    model: "provincestate",
  },
  {
    label: "Start Date",
    displayLabel: "Start Date",
    model: "start_date_text",
  },
  {
    label: "Compensation",
    displayLabel: "Compensation",
    model: "compensation",
  },
  {
    label: "Categories",
    displayLabel: "Categories",
    model: "types",
  }
]

export const DEFAULT_PLACEMENT_JOB_STATUSES = [
  "Draft",
  "Requested",
  "Posted",
  "Broadcasted",
  "Active",
  "Inactive",
  "Interviewing",
  "Trialing",
  "Placed",
  "Invoice Sent",
  "Invoice Paid",
  "Replacement",
  "Followed Up",
  "Closed",
  "Filled"
];

export const DEFAULT_PROFILE_IMAGE =
  "https://d10217p7vdlmii.cloudfront.net/media/profile_pics/default_avatar.jpg";

export const DEFAULT_PROFILE_IMAGE_SUFFIX =
  "/media/profile_pics/default_avatar.jpg";

export const DEFAULT_TEMPLATE_2_PARAMS = {
  nameHeader: {
    text: "[[first_name]] [[last_name]]",
    fontSize: "60px",
    fontFamily: "Open Sans",
    color: "white"
  },
  userType: {
    text: "[[types]]",
    fontSize: "40px",
    fontFamily: "Arizonia",
    color: "black"
  },
  leftContent: "Click Edit button to customize content",
  rightSection1: {
    header: {
      text: "Nanny Bio",
      fontSize: "40px",
      fontFamily: "Open Sans",
      color: "black"
    },
    content: "Click Edit button to customize content"
  },
  rightSection2: {
    header: {
      text: "Highlights",
      fontSize: "40px",
      fontFamily: "Open Sans",
      color: "black"
    },
    content: "Click Edit button to customize content"
  },
  imgLogo: {
    width: "200px"
  },
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE
  },
  imgOther: {
    src:
      "https://s3.ca-central-1.amazonaws.com/agency.enginehire.io/graphics/enginehire_icon_1.1.png",
    width: "250px"
  },
  backgroundColor: {
    top: "#4e5c50",
    left: "#f9b696",
    rightHeader1: "#d5d4d2",
    rightHeader2: "#d5d4d2"
  }
};

export const DEFAULT_TEMPLATE_3_PARAMS = {
  nameHeader: {
    text: "[[first_name]] [[last_name]]",
    fontSize: "60px",
    fontFamily: "Open Sans",
    color: "#565656"
  },
  image1: {
    src:
      "https://s3.ca-central-1.amazonaws.com/agency.enginehire.io/graphics/enginehire_icon_1.1.png",
    width: "250px"
  },
  image2: {
    src:
      "https://s3.ca-central-1.amazonaws.com/agency.enginehire.io/graphics/enginehire+logo+thin+dark+1.0.png",
    width: "100px"
  },
  contentHeader: "Click Edit button to customize content",
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE
  },
  backgroundColor: {}
};

export const DEFAULT_TEMPLATE_4_PARAMS = {
  nameHeader: {
    text: "[[first_name]] [[last_name]]",
    fontSize: "60px",
    fontFamily: "Open Sans",
    color: "#565656"
  },
  leftContent: "Click Edit button to customize content",
  rightContent1: "Click Edit button to customize content",
  rightContent2: "Click Edit button to customize content",
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE
  },
  backgroundColor: {
    left: "#f9b696"
  },
  imgLogo: {
    width: "200px"
  }
};

export const DEFAULT_TEMPLATE_5_PARAMS = {
  topContent: "Click Edit button to customize content",
  middleContent: "Click Edit button to customize content",
  leftContent: "Click Edit button to customize content",
  rightContent: "Click Edit button to customize content",
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE
  },
  backgroundColor: {
    bottom: "rgba(239, 224, 221, 0.6)"
  }
};

export const DEFAULT_TEMPLATE_6_PARAMS = {
  nameHeader: {
    text: "[[first_name]] [[last_name]]",
    fontSize: "60px",
    fontFamily: "Open Sans",
    color: "#565656"
  },
  leftContent: "Click Edit button to customize content",
  rightContent1: "Click Edit button to customize content",
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE
  },
  backgroundColor: {
    left: "#f9b696"
  },
  slogan: "Click Edit button to customize content",
  image1: {
    width: "200px",
    src:
      "https://d10217p7vdlmii.cloudfront.net/media/files/enginehire_icon_1.1_e098b3dc-7edb-4e4c-b69a-69975474bfb6.png"
  }
};

export const DEFAULT_TEMPLATE_7_PARAMS = {
  topRightContent: "Click Edit button to customize content",
  bottomLeftContent: "Click Edit button to customize content",
  bottomRightContent: "Click Edit button to customize content"
};

export const DEFAULT_TEMPLATE_8_PARAMS = {
  content: "Click Edit button to customize content"
};

export const DEFAULT_TEMPLATE_9_PARAMS = {
  presentedByText: {
    text: "Presented by",
    fontSize: "16px",
  },
  imgLogo: {
    height: "50px"
  },
  topRight: {
    content: "Click Edit button to customize content",
  },
  bottomLeft: {
    content: "Click Edit button to customize content",
  },
  bottomRight: {
    content: "Click Edit button to customize content",
  },
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE,
    height: '180px',
  },
  backgroundColor: {
    left: '#f3efed',
    separatorBar: '#ded5cc'
  },
  separatorBarHeight: "50px",
};

export const DEFAULT_TEMPLATE_11_PARAMS = {
  imgLogo: {
    height: "50px"
  },
  topRight: {
    content: "Click Edit button to customize content",
  },
  bottomLeft: {
    content: "Click Edit button to customize content",
  },
  bottomRight: {
    content: "Click Edit button to customize content",
  },
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE,
    height: '180px',
  },
  backgroundColor: {
    left: '#f3efed',
    separatorBar: '#ded5cc'
  },
};

export const DEFAULT_NAV_BAR_COLOR = "#e9ecef";
export const DEFAULT_NAV_BAR_TEXT_COLOR = "#1f4e78";
export const DEFAULT_COLOR_PICKER_OPTIONS = [
  "#1FBC9C",
  "#1CA085",
  "#2ECC70",
  "#27AF60",
  "#3398DB",
  "#2980B9",
  "#A463BF",
  "#8E43AD",
  "#3D556E",
  "#222F3D",
  "#F2C511",
  "#F39C19",
  "#E84B3C",
  "#C0382B",
  "#DDE6E8",
  "#BDC3C8"
];

export const DEFAULT_FAVICON_URL =
  "https://agency.enginehire.io/favicon1.1.ico";

export const DEFAULT_HEADING_CANDIDATE_INTERVIEW = [
  "Phone Screen Notes",
  "Interview Notes",
  "Candidate Interview 3",
  "Candidate Interview 4"
];

export const DEFAULT_HEADING_CLIENT_INTERVIEW = [
  "Welcome Call Notes",
  "Consultation Notes",
  "Client Interview 3",
  "Client Interview 4"
];

export const DEFAULT_PLACEMENT_JOB_BOARD_FIELDS = [
  {
    label: "Compensation",
    displayLabel: "Compensation",
    model: "compensation"
  },
  {
    label: "Children Description",
    displayLabel: "Children",
    model: "children_description"
  },
  { label: "Start Date Text", displayLabel: "Start", model: "start_date_text" },
  // { label: "Date", displayLabel: "Start Date", model: "date" },
  { label: "Text", displayLabel: "Schedule", model: "text" },
  { label: "Location", displayLabel: "Location", model: "location" }
];

export const DEFAULT_PLACEMENT_JOB_DETAIL_VIEW_FIELDS = [
  { label: "Location", displayLabel: "Location", model: "location" },
  { label: "Start Date Text", displayLabel: "Start", model: "start_date_text" },
  { label: "Date", displayLabel: "Start Date", model: "date" },
  { label: "Start Time", displayLabel: "Start Time", model: "start_time" },
  { label: "End Time", displayLabel: "End Time", model: "end_time" },
  { label: "Candidate Rate", displayLabel: "Hourly Rate", model: "candidate_rate" },
  { label: "Travel Fee", displayLabel: "Travel Fee", model: "travel_fee" },
  {
    label: "Children Description",
    displayLabel: "Children",
    model: "children_description"
  },
  {
    label: "Compensation",
    displayLabel: "Compensation",
    model: "compensation"
  },
  { label: "Text", displayLabel: "Schedule", model: "text" },
  { label: "Description", displayLabel: "Description", model: "description" },
];

export const DEFAULT_DISCLAIMER_TEXT = `Rates are subject to change, the
rate seen above is an approximation and may change based on your
specific circumstance once reviewed by our staff.`;
export const DEFAULT_MESSAGE_AUTO_ASSIGN_NO_CANDIDATE = "We do not have anyone available for this time at the moment, but you can still submit your request and we will try to match you with someone!";
export const DEFAULT_MESSAGE_SELF_SELECT_NO_AVAILABLE = "Unfortunately, there are no candidates currently available for the date and time you've selected."
export const DEFAULT_STATUS_REQUIRE_REASON_CHANGE = ['Rejected', 'Inactive'];

export const BOOKING_RESULT_DEFAULT_FIELDS = [
  {
    displayLabel: "Clocked Start Date",
    label: "Clocked Start Date",
    model: "actual_start_date",
    type: FORM_TYPE.DATEPICKER,
    itemPerRow: 2,
    isRequired: false,
  },
  {
    displayLabel: "Clocked End Date",
    label: "Clocked End Date",
    model: "actual_end_date",
    type: FORM_TYPE.DATEPICKER,
    itemPerRow: 2,
    isRequired: false,
  },
  {
    displayLabel: "Clocked Start Time",
    label: "Clocked Start Time",
    model: "actual_start_time",
    type: FORM_TYPE.TIME_PICKER,
    itemPerRow: 2,
    isRequired: false,
  },
  {
    displayLabel: "Clocked End Time",
    label: "Clocked End Time",
    model: "actual_end_time",
    type: FORM_TYPE.TIME_PICKER,
    itemPerRow: 2,
    isRequired: false,
  },
  {
    displayLabel: "Breaks",
    label: "Breaks",
    model: "breaks",
  },
  {
    displayLabel: "Hours Worked",
    label: "Hours Worked",
    model: "hours_worked",
    isRequired: false,
  },
  {
    displayLabel: "Regular Hours",
    label: "Regular Hours",
    model: "regular_hours",
  },
  {
    displayLabel: "OT Hours",
    label: "OT Hours",
    model: "ot_hours",
  },
  {
    displayLabel: "Total Paid",
    label: "Total Paid",
    model: "decimal4",
    isRequired: false,
    prefix: "$",
  },
  {
    displayLabel: "Clock In Notes",
    label: "Clock In Notes",
    model: "clock_in_notes",
    type: FORM_TYPE.TEXTAREA,
    isRequired: false,
  },
  {
    displayLabel: "Clock Out Notes",
    label: "Clock Out Notes",
    model: "clock_out_notes",
    type: FORM_TYPE.TEXTAREA,
    isRequired: false,
  },
  {
    displayLabel: "Admin Notes",
    label: "Admin Notes",
    model: "admin_notes",
    type: FORM_TYPE.TEXTAREA,
    isRequired: false,
  },
];
export const DEFAULT_DO_NOT_WANT_AGAIN_TEXT = "We will do our best to connect you with others in the future.";

export const DEFAULT_SHIFT_JOB_CALENDAR_TITLE = "[[poster_name]] [[start_time]] - [[end_time]] [[title]] ([[status]] - [[filler_name]]) {[[number_application]]}";

export const DEFAULT_SHIFT_JOB_CALENDAR_TITLE_AVAILABLE_JOB_BOARD = "[[poster_first_name]] [[start_time]] - [[end_time]]";

export const DEFAULT_LOGIN_PAGE_HELPER_TEXT = "First time logging in? Please try your email address as your password!";

export const DEFAULT_REQUEST_TIME_OFF_CATEGORIES = ['Holiday', 'Sick', 'Unpaid', 'Paid'];

export const DEFAULT_SHIFT_JOB_CANCELLATION_REASON_LIST = ['Client Cancelled', 'Candidate Cancelled', 'Other']

export const DEFAULT_CANDIDATE_AVAILABLE_JOBS_TABLE_FIELDS = [
  {
    label: "Booked Date",
    displayLabel: "Booked Date",
    model: "date",
  },
  {
    label: "Booked Start Time",
    displayLabel: "Booked Start Time",
    model: "start_time",
  },
  {
    label: "Booked End Time",
    displayLabel: "Booked End Time",
    model: "end_time",
  },
  {
    label: "Poster",
    displayLabel: "Poster",
    model: "poster_name",
  },
  {
    label: "Distance",
    displayLabel: "Distance",
    model: "distance",
  },
];

export const DEFAULT_CANDIDATE_TABLE_JOB_FIELD_KEYS = 'id,date,end_date,start_time,end_time,status,title,category,filled,filler,filler_id,filler_name,poster,poster_id,poster_name,poster__first_name,poster__last_name,poster__types,poster__status,poster__tags,poster__locations,poster__email,poster__employer_name,decimal4,mileage,actual_start_date,actual_start_time,actual_end_date,actual_end_time,agency_id,locations,location,latitude,longitude,text3,text4,text5,admin_notes,hours_worked,total_candidate_pay,total_client_charge,tip,admin_fee,admin_fee_subtraction,rush_fee,per_booking_agency_fee,per_booking_candidate_fee,additional_fee,breaks,clock_in_notes,clock_out_notes,candidate_rate,client_rate,agency_fee,travel_fee,poster__stripe_customer_id,filler__stripe_connect_id,poster__authorize_net_profile,address1,address2,scraper_account__account_type,scraper_account__name,selector1,agency,type,city';

export const DEFAULT_CANDIDATE_ACCEPT_JOB_CONFIRM_MESSAGE = '<h2>You are committing to filling this job, are you sure?</h2>'

export const DEFAULT_CANDIDATE_ACCEPT_JOB_BUTTON_TEXT = 'Accept Job'

export const USER_EXPORT_OPTIONS = [
  {
    displayLabel: "First Name",
    label: "First Name",
    model: "first_name",
  },
  { displayLabel: "Last Name", label: "Last Name", model: "last_name" },
  { displayLabel: "Email", label: "Email", model: "email" },
  { displayLabel: "Status", label: "Status", model: "status" },
  {
    displayLabel: "Date Registered",
    label: "Date Registered",
    model: "created_date",
  },
  { displayLabel: "User ID", label: "User ID", model: "id" },
  {
    displayLabel: "Address",
    label: "Address",
    model: "address1",
  },
  {
    displayLabel: "Address 2",
    label: "Address 2",
    model: "address2",
  },
  { displayLabel: "City", label: "City", model: "city" },
  {
    displayLabel: "Postal Code",
    label: "Postal Code",
    model: "postal_code",
  },
  {
    displayLabel: "State",
    label: "State",
    model: "provincestate",
  },
  {
    displayLabel: "Country",
    label: "Country",
    model: "country",
  },
  {
    displayLabel: "Phone",
    label: "Phone",
    model: "phone",
  },
  {
    displayLabel: "Phone 2",
    label: "Phone 2",
    model: "phone2",
  },
  { displayLabel: "Email 2", label: "Email 2", model: "email2" },
  {
    displayLabel: "Last Login",
    label: "Last Login",
    model: "last_login",
  },
  {
    displayLabel: "Types",
    label: "Types",
    model: "types",
  },
  {
    displayLabel: "Time in Status",
    label: "Time in Status",
    model: "time_in_status"
  }
]

export const DEFAULT_USER_EXPORT_OPTIONS = [
  {
    displayLabel: "First Name",
    label: "First Name",
    model: "first_name",
  },
  { displayLabel: "Last Name", label: "Last Name", model: "last_name" },
  { displayLabel: "Email", label: "Email", model: "email" },
  { displayLabel: "Status", label: "Status", model: "status" },
  {
    displayLabel: "Date Registered",
    label: "Date Registered",
    model: "created_date",
  },
  {
    displayLabel: "Address",
    label: "Address",
    model: "address1",
  },
  { displayLabel: "City", label: "City", model: "city" },
  {
    displayLabel: "Postal Code",
    label: "Postal Code",
    model: "postal_code",
  },
  {
    displayLabel: "State",
    label: "State",
    model: "provincestate",
  },
  {
    displayLabel: "Phone",
    label: "Phone",
    model: "phone",
  },
  {
    displayLabel: "Last Login",
    label: "Last Login",
    model: "last_login",
  },
  {
    displayLabel: "Profile Link",
    label: "Profile Link",
    model: "profile_link",
  },
]

export const DEFAULT_ANALYTICS_DASHBOARD_SELECTION = ["types", "tags", "locations"];

export const DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT = "I have a problem";
export const DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL = "Upload Files";
export const DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION = "Please upload files";
export const DEFAULT_REPORT_PROBLEM_NOTE_LABEL = "Additional Notes";

export const DEFAULT_DATEPICKER_FIELD = {
  FORMAT: "YYYY-MM-DD",
  PLACEHOLDER: "YYYY-MM-DD"
}

export const DEFAULT_PROFILE_TOP_WELCOME_TEXT = "Welcome to [[agency_name]], [[first_name]]";

export const DEFAULT_SCHEDULE_EVENT_TYPES = [
  "Phone Interview",
  "Video Interview",
  "In Person Interview",
  "Other",
];

export const DEFAULT_EMAIL_STATUSES = {
  Open: {
    display: "Opened",
    color: "green"
  },
  Delivery: {
    display: "Delivered",
    color: "blue"
  },
  Bounce: {
    display: "Bounce",
    color: "gray"
  }
};

export const DEFAULT_BUTTON_TEXT_CANDIDATE_MARK_JOB_COMPLTED = "Mark as Completed";
export const DEFAULT_STATUS_CANDIDATE_MARK_JOB_COMPLTED = "Completed";

export const ANALYTICS_DASHBOARD_PREDEFINED_OPTIONS = [{
  label: "Types",
  model: "types",
  isMulti: true,
},
{
  label: "Tags",
  model: "tags",
  isMulti: true,
},
{
  label: "Locations",
  model: "locations",
  isMulti: true,
},
{
  label: "Status",
  model: "status",
}];

export const DEFAULT_REFERENCE_TABLE_FIELDS_OPTIONS = [
  {
    label: "Reference Name",
    displayLabel: "Reference Name",
    model: "reference_name",
  },
  {
    label: "User Name",
    displayLabel: "User Name",
    model: "user_name",
  },
  {
    label: "User Status",
    displayLabel: "User Status",
    model: "reference_provider_status",
  },
  {
    label: "User Second Status",
    displayLabel: "User Second Status",
    model: "reference_provider_second_status",
  },
  {
    label: "Phone Number",
    displayLabel: "Phone Number",
    model: "phone",
  },
  {
    label: "Email Address",
    displayLabel: "Email Address",
    model: "email",
  },
  {
    label: "Locations",
    displayLabel: "Locations",
    model: "reference_provider_locations",
  },
  {
    label: "Check Completion Date",
    displayLabel: "Check Completion Date",
    model: "check_completion_date",
  },
  {
    label: "IP Tracking",
    displayLabel: "IP Tracking",
    model: "ip_address",
  }
]

export const DEFAULT_TEMPLATE_10_PARAMS = {
  nameHeader: {
    text: "[[first_name]] [[last_name]]",
    fontSize: "30px",
    fontFamily: "Open Sans",
    color: "white"
  },
  userType: {
    text: "[[types]]",
    fontSize: "40px",
    fontFamily: "Arizonia",
    color: "black"
  },
  aboutMeSection: {
    header: {
      text: "About Me",
      fontSize: "40px",
      fontFamily: "Open Sans",
      color: "black"
    },
    content: "Click Edit button to customize content"
  },
  rightSection1: {
    header: {
      text: "Info Details",
      fontSize: "40px",
      fontFamily: "Open Sans",
      color: "black"
    },
    content: "Click Edit button to customize content"
  },
  rightSection2: {
    header: {
      text: "Achievements",
      fontSize: "40px",
      fontFamily: "Open Sans",
      color: "black"
    },
    content: "Click Edit button to customize content"
  },
  imgLogo: {
    width: "200px"
  },
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE
  },
  imgOther: {
    src:
      "https://s3.ca-central-1.amazonaws.com/agency.enginehire.io/graphics/enginehire_icon_1.1.png",
    width: "140px",
    height: "140px"
  },
  backgroundColor: "#f9b696",
  backgroundImage: ''
};

export const DEFAULT_TEXT_SUBMIT_JOB_FOR_BLOCKED_DATES = '<h5>The date is full and the booking request will be added to the waitlist</h5>'

export const DEFAULT_PRICE_INFO_ITEMS_PLACEMENT = [
  'Booking Rate',
  'Client Rate',
  'Candidate Rate',
  'Agency Fee',
  'Travel Fee',
  'Rush Fee',
  'Candidate Rush Fee',
  'Booking Fee',
  'Per Booking Fee',
  'Per Booking Agency Fee',
  'Per Booking Candidate Fee'
];

export const DEFAULT_PLACEMENT_JOB_FILTER_FIELDS = [
  {
    label: "Filter by Status",
    model: "status"
  },
  {
    label: "Filter by Locations",
    model: "locations"
  },
  {
    label: "Filter by Manager",
    model: "admin_manager"
  },
  {
    label: "Filter by Client",
    model: "poster_id"
  },
  {
    label: "Filter by Categories",
    model: "types"
  },
];

export const DEFAULT_RELATIONSHIP_STATUSES_HIDDEN_MY_CANDIDATES = ["Potential Fit",
  "Candidate Consideration",
  "Candidate Interested",
  "Candidate Not Interested",
  "Do Not Match"]

export const DEFAULT_MESSAGE_BOOKING_OUTSIDE_OFFICE_HOUR = `
  <h4>
  Hello! Sorry, our office hours are from [[office_hour_from]] to [[office_hour_to]]<br/>
  Please book during this time and we will be happy to assist you!
  </h4>
`



// WEBPACK FOOTER //
// ./src/constants/default-values.js